var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "延期停车月卡",
        visible: _vm.visible,
        width: "640px",
        "append-to-body": "",
        "close-on-click-modal": false,
        "before-close": _vm.handleCancel,
        "custom-class": "delay-parking-card-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "delay-alert" }, [
        _vm._v(
          "\n    延期用于延长月卡生效时间。延期成功后，月卡开始时间保持不变，仅延长月卡到期时间。延期期间月卡正常生效。\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "form",
          staticClass: "delay-form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "120px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "商品名称" } },
            [
              _c("el-input", {
                attrs: { value: _vm.display.productName, disabled: "" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "停车场名称" } },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.display.parkName,
                    placement: "top",
                    disabled: !_vm.display.parkName,
                    "popper-class": "parking-name-tooltip",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { value: _vm.display.parkName, disabled: "" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "车牌号" } },
            [
              _c("el-input", {
                attrs: { value: _vm.display.plateNo, disabled: "" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "月卡开始时间" } },
            [
              _c("el-input", {
                attrs: { value: _vm.display.validStartTime, disabled: "" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "field-tip" }, [
                _vm._v("月卡开始时间保持不变，不受延期操作影响。"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "当前到期时间" } },
            [
              _c("el-input", {
                attrs: { value: _vm.display.validEndTime, disabled: "" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "延期时长", prop: "days" } }, [
            _c(
              "div",
              { staticClass: "delay-days-row" },
              [
                _c("el-input", {
                  staticClass: "delay-days-input",
                  model: {
                    value: _vm.form.days,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "days", $$v)
                    },
                    expression: "form.days",
                  },
                }),
                _vm._v(" "),
                _c("span", [_vm._v("天")]),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "field-tip" }, [
              _vm._v("选择延期天数后，系统自动计算新的月卡到期时间。"),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "延期原因" } },
            [
              _c("el-input", {
                staticClass: "reason-textarea",
                attrs: {
                  type: "textarea",
                  rows: 3,
                  maxlength: "100",
                  "show-word-limit": "",
                  placeholder: "请输入延期原因",
                },
                model: {
                  value: _vm.form.reason,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "reason", $$v)
                  },
                  expression: "form.reason",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "上传附件", required: "" } }, [
            _c(
              "div",
              {
                staticClass: "attach-box",
                on: { click: _vm.chooseAttachment },
              },
              [
                _vm.form.attachment
                  ? [
                      _vm.form.attachment.extName !== "pdf"
                        ? _c("img", {
                            staticClass: "attach-preview",
                            attrs: { src: _vm.form.attachment.url, alt: "" },
                          })
                        : _c("i", {
                            staticClass: "el-icon-document attach-pdf",
                          }),
                      _vm._v(" "),
                      _c("div", { staticClass: "attach-name" }, [
                        _vm._v(_vm._s(_vm.form.attachment.fileName)),
                      ]),
                    ]
                  : [
                      _c("div", { staticClass: "attach-plus" }, [_vm._v("+")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "attach-link" }, [
                        _vm._v("从素材库选择附件"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "attach-hint" }, [
                        _vm._v("支持 JPG、PNG、PDF，单个文件不超过1MB"),
                      ]),
                    ],
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "field-tip" }, [
              _vm._v("附件为必填项，用于留存延期申请/审批凭证。"),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("取消"),
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitting },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v("确认延期")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }